import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Download from "@material-ui/icons/GetApp";
import FileSaver from "file-saver";

import Typography from "components/Typography";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    maxWidth: 900,
    margin: "auto",
  },
  document: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      padding: 20,
      backgroundColor: "white",
      marginBottom: 16,
      fontWeight: 600,
    },
  },
  name: {
    marginLeft: 20,
    fontSize: 24,
    color: "#413f3f",
    flex: 1,
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      marginLeft: 0,
    },
  },
  separator: {
    borderBottom: "1px solid #d8d8d8",
    marginTop: 16,
    marginBottom: 65,
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  download: {
    color: "#c48a43",
  },
  size: {
    color: "#c48a43",
    marginLeft: 20,
    fontFamily: "Aileron",
    marginRight: 40,
    width: 100,
    textAlign: "right",
    [theme.breakpoints.down("xs")]: {
      marginRight: 0,
      marginLeft: 16,
    },
  },
}));

const AGM = (props) => {
  const classes = useStyles();

  const documents = [
    {
      name: "Management Information Circular",
      link: "//assets.ctfassets.net/ukstf33kj625/n7hdNmwDWn8J9vTAunpug/7ff3090a8c9ec1e65cb6cccb708e4260/Kadestone_Capital_Corp._-_Management_information_circular_-_English_-_2026-05-28.pdf",
      size: "645 KB",
    },
    {
      name: "Form of Proxy",
      link: "//assets.ctfassets.net/ukstf33kj625/1kV0P5FSFZR17jUU4PGjfO/d088f7a93b325cd6d505b1ca48486060/Kadestone_Capital_Corp._-_Form_of_proxy_-_English_-_2026-05-28.pdf",
      size: "131 KB",
    },
    {
      name: "2025 Annual Financial Statements",
      link: "//assets.ctfassets.net/ukstf33kj625/55euTdI9wLCIc7vNt2LIta/be265dd34003e3b259a2e9431ba5cdcf/Kadestone_Capital_Corp._-_Audited_annual_financial_statements_-_English_-_2026-05-04.pdf",
      size: "570 KB",
    },
    {
      name: "2025 MD&A",
      link: "//assets.ctfassets.net/ukstf33kj625/1bDHvDsmWUj99IHil9pNAd/495265cb2e48b4e32bfcbaf36c08ecad/Kadestone_Capital_Corp._-_Annual_MDA_-_English_-_2026-05-04.pdf",
      size: "432 KB",
    },
    {
      name: "Financial Statements Request Form",
      link: "//assets.ctfassets.net/ukstf33kj625/6JKHOJXd6fQShYGYDYnhxn/ccbc6aee16fba2c1b7514a87ddaf3701/Kadestone_Capital_Corp._-_Other_-_2026-05-28.pdf",
      size: "81 KB",
    },
  ];

  const downloadPdf = (link, title) => {
    FileSaver.saveAs(link, title);
  };

  return (
    <div className={classes.root}>
      {documents.map((x) => (
        <Fragment key={x.name}>
          <div className={classes.document}>
            <Typography variant="subtitle1" className={classes.name}>
              {x.name}
            </Typography>
            <IconButton onClick={() => downloadPdf(x.link, x.name)}>
              <Download className={classes.download} />
            </IconButton>
            <Typography className={classes.size}>{x.size}</Typography>
          </div>
          <div className={classes.separator} />
        </Fragment>
      ))}
    </div>
  );
};

AGM.propTypes = {};
AGM.defaultProps = {};

export default AGM;
